import { jsPDF } from "jspdf";
import { ToolboxTalkContent } from "./content/resources/toolboxTalks";
import { TemplateContent } from "./content/resources/templates";

export const generateTemplatePDF = async (template: TemplateContent): Promise<void> => {
  // Yield execution to allow UI updates (toasts, spinners) to render
  await new Promise(resolve => setTimeout(resolve, 100));

  const doc = new jsPDF();
  const pageWidth = doc.internal.pageSize.getWidth();
  
  // Branding
  doc.setFillColor(30, 58, 138); // Dark Blue
  doc.rect(0, 0, pageWidth, 40, 'F');
  
  doc.setTextColor(255, 255, 255);
  doc.setFontSize(20);
  doc.setFont("helvetica", "bold");
  doc.text(template.title.toUpperCase(), 20, 25);
  
  doc.setFontSize(10);
  doc.setFont("helvetica", "normal");
  doc.text("GENERAL-PURPOSE WORKSHEET | RUNOFFTRACK.COM", 20, 33);

  let y = 55;
  doc.setTextColor(0, 0, 0);

  // Core Fields
  const drawInput = (label: string, width = pageWidth - 40) => {
    doc.setFontSize(10);
    doc.setFont("helvetica", "bold");
    doc.text(label, 20, y);
    doc.setDrawColor(200);
    doc.line(20, y + 2, 20 + width, y + 2);
    y += 12;
  };

  drawInput("Project Name:");
  drawInput("Inspector Name / Credentials:");
  drawInput("Date/Time:");

  // Sections from content file
  template.sections.forEach(section => {
    if (y > 250) { doc.addPage(); y = 20; }
    y += 5;
    doc.setFontSize(12);
    doc.setFont("helvetica", "bold");
    doc.setFillColor(245, 245, 245);
    doc.rect(20, y - 5, pageWidth - 40, 8, 'F');
    doc.text(section.header, 25, y);
    y += 10;

    section.fields.forEach(field => {
        drawInput(field + " _________________________________");
    });
  });

  // Footer Signature
  y = 260;
  doc.setFontSize(8);
  doc.text("Review your applicable permit before use. Add project-specific fields and any required certification language.", 20, y, { maxWidth: pageWidth - 40 });
  y += 10;
  doc.line(20, y, 100, y);
  doc.text("Authorized Signature", 20, y + 5);

  await doc.save(`${template.id}_Template.pdf`, { returnPromise: true });
};

export const generateToolboxTalkPDF = async (talk: ToolboxTalkContent): Promise<void> => {
  // Yield execution to allow UI updates
  await new Promise(resolve => setTimeout(resolve, 100));

  const doc = new jsPDF();
  const pageWidth = doc.internal.pageSize.getWidth();

  // Header Bar
  doc.setFillColor(234, 88, 12); // Orange 600
  doc.rect(0, 0, pageWidth, 35, 'F');
  
  doc.setTextColor(255, 255, 255);
  doc.setFontSize(22);
  doc.setFont("helvetica", "bold");
  doc.text("SWPPP TOOLBOX TALK", 20, 20);
  
  doc.setFontSize(12);
  doc.text(talk.title, 20, 28);

  let y = 50;
  doc.setTextColor(0, 0, 0);

  const addBlock = (title: string, content: string | string[], isAlert = false) => {
    if (y > 240) { doc.addPage(); y = 20; }
    
    if (isAlert) {
        doc.setFillColor(255, 247, 237); // Light orange
        doc.rect(15, y - 5, pageWidth - 30, 25, 'F');
    }

    doc.setFontSize(11);
    doc.setFont("helvetica", "bold");
    doc.text(title, 20, y);
    y += 7;

    doc.setFontSize(10);
    doc.setFont("helvetica", "normal");
    
    if (Array.isArray(content)) {
        content.forEach(item => {
            doc.text("• " + item, 25, y, { maxWidth: pageWidth - 50 });
            y += 7;
        });
    } else {
        doc.text(content, 20, y, { maxWidth: pageWidth - 40 });
        y += 15;
    }
    y += 5;
  };

  addBlock("THE HAZARD", talk.hazard, true);
  addBlock("BEST PRACTICES", talk.bestPractices);
  addBlock("CREW DISCUSSION", talk.discussionPoints);

  // Pro Tip Box
  y += 5;
  doc.setDrawColor(234, 88, 12);
  doc.setLineWidth(0.5);
  doc.rect(20, y, pageWidth - 40, 20);
  doc.setFont("helvetica", "bold");
  doc.text("PRO-TIP:", 25, y + 8);
  doc.setFont("helvetica", "normal");
  doc.text(talk.proTip, 25, y + 14, { maxWidth: pageWidth - 50 });

  // Sign-in Sheet
  doc.addPage();
  y = 20;
  doc.setFontSize(16);
  doc.setFont("helvetica", "bold");
  doc.text("Attendance Log", 20, y);
  y += 10;
  doc.setFontSize(10);
  doc.text(`Topic: ${talk.title} | Date: ___________`, 20, y);
  y += 10;

  for (let i = 0; i < 15; i++) {
    doc.line(20, y, pageWidth - 20, y);
    y += 15;
  }
  doc.text("Name (Print)", 20, 45);
  doc.text("Signature", 120, 45);

  await doc.save(`ToolboxTalk_${talk.id}.pdf`, { returnPromise: true });
};
